import styled from "styled-components";



export const StyledFooter = styled.footer`
  color: black;
  background-color: rgb(0, 0, 0, 0.02);
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2em;
  padding: 2em;
  text-align: left;
  
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
    justify-content: space-around;
    align-items:center;
    min-height: 20vh;
    h2 {
      font-size: 5em;
    }
  }
`;
